module.exports = __webpack_public_path__ + "media/gocd_logo-1040334cb6e713526afcb636468fa8e5.svg";